import { ActionIcon, Box, Group } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';

import { ImageMantine } from '../../../DataDisplay';
import { Skeleton } from '../../../Feedback';
import { cx } from '../../../Provider/Provider';
import { Text } from '../../../Typography';
import classes from './DarkModalHeader.module.css';

type DarkModalHeaderProps = {
  children: (emphasize?: (text: string) => React.ReactNode) => JSX.Element;
  causeImg?: string;
  withBackButton?: boolean;
  isLoading?: boolean;
  showImage?: boolean;
};

const DarkModalHeader = ({
  children,
  causeImg,
  withBackButton,
  isLoading = false,
  showImage = true,
}: DarkModalHeaderProps) => {
  return (
    <Group
      wrap="nowrap"
      align="flex-start"
      className={cx('DarkModalHeader', classes.DarkModalHeader)}
    >
      {withBackButton && (
        <ActionIcon variant="transparent" c="white">
          <IconChevronLeft brand="tabler" />
        </ActionIcon>
      )}
      {showImage && (
        <Skeleton visible={isLoading} className={classes.DarkModalHeader__causeImageSkeleton}>
          <Box className={classes.DarkModalHeader__causeImageContainer}>
            <ImageMantine src={causeImg} className={classes.DarkModalHeader__causeImage} />
          </Box>
        </Skeleton>
      )}

      <Skeleton visible={isLoading} mih={48}>
        <Text className={classes.DarkModalHeader__headerText}>
          {children((textToEmphasize) => (
            <Text className={classes['DarkModalHeader__headerText--emphasized']} component="span">
              {textToEmphasize}
            </Text>
          ))}
        </Text>
      </Skeleton>
    </Group>
  );
};

export { DarkModalHeader };
